if (!customElements.get("product-reviews-swiper")) {
    customElements.define(
        "product-reviews-swiper",
        class ProductReviewsSwiper extends HTMLElement {
            constructor() {
                super();
                this.swiper = this.querySelector(".swiper");
                this.pagination = this.querySelector(".swiper-pagination");
                this.reviewsDataEl = this.querySelector('.product__reviews-data div');
                this.reviewsCount = this.reviewsDataEl.dataset.numberOfReviews;
                this.reviewsAvg = this.reviewsDataEl.dataset.averageRating;

                this.titleEl = this.parentElement.parentElement.querySelector('.product__reviews-title');

                this.targetAvg = this.titleEl.querySelector('.product__reviews-avg');
                this.targetCount = this.titleEl.querySelector('.product__reviews-counts');
                this.targetCountB = this.querySelector('.product__reviews-see-all span');

                this.button = this.querySelectorAll('.product__reviews-item-content__read-more');
                this.buttonB = this.querySelector('.product__reviews-see-all');
                this.widget = document.querySelector('.jdgm-review-widget');
            }

            connectedCallback() {
                this.initSwiper();
                this.updateData();
                this.buttonClick();
            }

            initSwiper() {
                new Swiper(this.swiper, {
                    slidesPerView: 'auto',
                    pagination: {
                        el: this.pagination,
                        clickable: true,
                    },
                });
            }

            updateData() {
                this.targetAvg.textContent = this.reviewsAvg;
                this.targetCount.textContent = this.reviewsCount;
                this.targetCountB.textContent = this.reviewsCount;
            }

            buttonClick() {
                if (this.button.length) {
                    this.button.forEach((item) => {
                        item.addEventListener('click', this.toggleReadMore.bind(this));
                    });
                }
                if (this.buttonB) {
                    this.buttonB.addEventListener('click', this.toggleReadMore.bind(this));
                }

            }

            toggleReadMore() {
                this.widget.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        })
}